import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Coleta from "model/transportes/coleta/Coleta";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ColetaService implements BaseServiceCadastros<Coleta> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/coleta/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Coleta>((resolve, reject): void => {
            api
                .get(`/coleta/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(coleta: Coleta) {
        return new Promise<Coleta>((resolve, reject): void => {
            api
                .post(`/coleta/incluir`, coleta)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(coleta: Coleta) {
        return new Promise<Coleta>((resolve, reject): void => {
            api
                .put(`/coleta/editar`, coleta)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/coleta/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/coleta/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListStatus() {
        return [
            { label: "Criada", value: "CRIADA" },
            { label: "Em andamento", value: "EM_ANDAMENTO" },
            { label: "Finalizada", value: "FINALIZADA" },
        ]
    }
    getStatusLabel(value: string) {
        return this.getListStatus().find(status => status.value === value)?.label;
    }

}

export default ColetaService;